import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { verifyToken } from '../services/authService';
import { FaSpinner, FaTrash, FaArrowLeft, FaUtensils } from 'react-icons/fa';

const OTP_EXPIRY_TIME = 300; // 5 minutes (in seconds)

const CustomerSubscribe = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [step, setStep] = useState('checking');
  const [error, setError] = useState('');
  const [restaurant, setRestaurant] = useState(null);
  const [otpTimer, setOtpTimer] = useState(OTP_EXPIRY_TIME);
  const [otpInterval, setOtpInterval] = useState(null);
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem('customerToken'));
  const [alreadySubscribed, setAlreadySubscribed] = useState(false); // Add state to track if already subscribed

  // Add processing states
  const [isProcessingPhone, setIsProcessingPhone] = useState(false);
  const [isProcessingVerification, setIsProcessingVerification] =
    useState(false);
  const [isProcessingSubscribe, setIsProcessingSubscribe] = useState(false);
  const [isProcessingResendOtp, setIsProcessingResendOtp] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const checkAuthAndSubscription = async () => {
  //     if (token) {
  //       try {
  //         const response = await verifyToken(token);
  //         if (response.valid) {
  //           const isSubscribed = await checkSubscription();
  //           if (isSubscribed) {
  //             setAlreadySubscribed(true); // Mark customer as already subscribed
  //             setStep('success'); // Show success message
  //           } else {
  //             setStep('subscribe');
  //           }
  //         } else {
  //           setStep('phone');
  //         }
  //       } catch (error) {
  //         setStep('phone');
  //       }
  //     } else {
  //       setStep('phone');
  //     }
  //   };

  //   const fetchRestaurantDetails = async () => {
  //     try {
  //       const response = await axios.get(`/api/restaurants/${restaurantId}`);
  //       // setRestaurant(response.data);
  //       if (response.data) {
  //         setRestaurant(response.data);
  //       } else {
  //         setError('Restaurant not found or no longer available.');
  //         setStep('error'); // Add a new 'error' step to handle this case
  //       }
  //     } catch (error) {
  //       // setError('Failed to load restaurant information.');
  //       setError('Failed to load restaurant information.');
  //       setStep('error');
  //     }
  //   };

  //   // checkAuthAndSubscription();
  //   // fetchRestaurantDetails();

  //   const fetchData = async () => {
  //     setIsLoading(true);
  //     try {
  //       await fetchRestaurantDetails();
  //       await checkAuthAndSubscription();
  //     } catch (error) {
  //       setError('Failed to load necessary information.');
  //       setStep('error');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [token, restaurantId]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const restaurantResponse = await fetchRestaurantDetails();
        if (restaurantResponse) {
          await checkAuthAndSubscription();
        }
      } catch (error) {
        setError('Failed to load necessary information.');
        setStep('error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [restaurantId]);

  const fetchRestaurantDetails = async () => {
    try {
      const response = await axios.get(`/api/restaurants/${restaurantId}`);
      if (response.data) {
        setRestaurant(response.data);
        return true;
      } else {
        setError('Restaurant not found or no longer available.');
        setStep('error');
        return false;
      }
    } catch (error) {
      setError('Failed to load restaurant information.');
      setStep('error');
      return false;
    }
  };

  const checkAuthAndSubscription = async () => {
    if (token) {
      try {
        const response = await verifyToken(token);
        if (response.valid) {
          const isSubscribed = await checkSubscription();
          console.log(isSubscribed);
          if (isSubscribed) {
            console.log('checking');
            setAlreadySubscribed(true);
            setStep('success');
          } else {
            setStep('subscribe');
          }
        } else {
          setStep('phone');
        }
      } catch (error) {
        setStep('phone');
      }
    } else {
      setStep('phone');
    }
  };
  const checkSubscription = async () => {
    try {
      const response = await axios.get(
        `/api/customers/subscription/${restaurantId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      // return response.data.isSubscribed;
      // return response.data.isSubscribed && response.data.restaurantExists;
      return response.data.isSubscribed;
    } catch (error) {
      return false;
    }
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingPhone(true); // Show processing state
    try {
      await axios.post('/api/auth/customer/login', { phoneNumber });
      setStep('verify');
      startOtpTimer();
    } catch (error) {
      setError('Failed to send verification code. Please try again.');
    } finally {
      setIsProcessingPhone(false); // Hide processing state
    }
  };

  const startOtpTimer = () => {
    if (otpInterval) clearInterval(otpInterval);
    setOtpTimer(OTP_EXPIRY_TIME);
    const interval = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);
    setOtpInterval(interval);
  };

  const handleResendOtp = async () => {
    setError('');
    setIsProcessingResendOtp(true); // Show processing state for resend OTP
    try {
      await axios.post('/api/auth/customer/login', { phoneNumber });
      startOtpTimer();
    } catch (error) {
      setError('Failed to resend OTP. Please try again.');
    } finally {
      setIsProcessingResendOtp(false); // Hide processing state
    }
  };

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingVerification(true); // Show processing state for verification
    try {
      const response = await axios.post('/api/auth/customer/verify-otp', {
        phoneNumber,
        verificationCode,
      });
      if (response.data.token) {
        localStorage.setItem('customerToken', response.data.token);
        setToken(response.data.token);
        const isSubscribed = await checkSubscription();
        setStep(isSubscribed ? 'success' : 'subscribe');
        setAlreadySubscribed(isSubscribed); // Update already subscribed state
        console.log('already subscribed');
      }
    } catch (error) {
      setError('Invalid verification code. Please try again.');
    } finally {
      setIsProcessingVerification(false); // Hide processing state
    }
  };

  const handleSubscribe = async () => {
    setError('');
    setIsProcessingSubscribe(true); // Show processing state for subscription
    try {
      const response = await axios.post(
        `/api/customers/subscribe/${restaurantId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setStep('success');
      } else {
        setError('Subscription failed. Please try again.');
      }
    } catch (error) {
      setError('Failed to subscribe. Please try again.');
      localStorage.removeItem('customerToken');
      setStep('phone');
    } finally {
      setIsProcessingSubscribe(false); // Hide processing state
    }
  };

  const handleGoBack = () => {
    setStep('phone');
    setVerificationCode('');
    clearInterval(otpInterval);
    setOtpTimer(OTP_EXPIRY_TIME);
  };

  const renderStep = () => {
    switch (step) {
      case 'checking':
        // return <div>Checking your authentication...</div>;
        return (
          <div className='flex justify-center items-center'>
            <div className='animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500'></div>
          </div>
        ); // Show loading state
      case 'phone':
        return (
          <form onSubmit={handlePhoneSubmit} className='space-y-4'>
            <div>
              <label
                htmlFor='phoneNumber'
                className='block text-sm font-medium text-gray-700'
              >
                Phone Number
              </label>
              <input
                type='tel'
                id='phoneNumber'
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Enter your phone number'
              />
            </div>
            {error && <p className='text-red-500 text-sm'>{error}</p>}
            <button
              type='submit'
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingPhone}
            >
              {isProcessingPhone ? 'Processing...' : 'Send Verification Code'}
            </button>
          </form>
        );
      case 'verify':
        return (
          <form onSubmit={handleVerificationSubmit} className='space-y-4'>
            <div>
              <label
                htmlFor='verificationCode'
                className='block text-sm font-medium text-gray-700'
              >
                Verification Code
              </label>
              <input
                type='text'
                id='verificationCode'
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Enter verification code'
              />
            </div>
            {error && <p className='text-red-500 text-sm'>{error}</p>}
            <button
              type='submit'
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingVerification}
            >
              {isProcessingVerification
                ? 'Processing...'
                : 'Verify and Subscribe'}
            </button>
            <button
              onClick={handleGoBack}
              className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400'
            >
              Go Back
            </button>
            <button
              onClick={handleResendOtp}
              className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400'
              disabled={isProcessingResendOtp}
            >
              {isProcessingResendOtp ? 'Processing...' : 'Resend OTP'}
            </button>
            <p>OTP expires in {otpTimer} seconds</p>
          </form>
        );
      case 'subscribe':
        return (
          <div className='text-center'>
            <p className='text-xl font-semibold text-gray-600 mb-4'>
              Subscribe to receive updates from {restaurant?.name}
            </p>
            <button
              onClick={handleSubscribe}
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingSubscribe}
            >
              {isProcessingSubscribe ? 'Processing...' : 'Subscribe'}
            </button>
          </div>
        );
      case 'success':
        return (
          <div className='text-center'>
            <p className='text-xl font-semibold text-green-600 mb-4'>
              {alreadySubscribed
                ? 'You are already subscribed. Welcome back!'
                : 'Successfully Subscribed!'}
            </p>
            <p>You will now receive messages from {restaurant?.name}.</p>
          </div>
        );

      // Add a new case in the renderStep function:
      case 'error':
        return (
          // <div className='text-center'>
          //   <p className='text-xl font-semibold text-red-600 mb-4'>{error}</p>
          // </div>
          <div className='text-center py-10'>
            <FaUtensils className='text-6xl text-gray-300 mx-auto mb-4' />
            <p className='text-xl text-gray-500'>{error}</p>
            <p className='text-gray-400 mt-2'>
              Restaurants does not exist or has been removed
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  if (isLoading) {
    return (
      <div className='flex justify-center items-center'>
        <div className='animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500'></div>
      </div>
    ); // Show loading state  }
  }

  return (
    <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
      {restaurant && (
        <h1 className='text-2xl font-bold mb-4 text-center'>
          {restaurant.name}
        </h1>
      )}
      {renderStep()}
    </div>
  );
};

export default CustomerSubscribe;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { verifyToken } from '../services/authService';

// const OTP_EXPIRY_TIME = 300; // 5 minutes (in seconds)

// const CustomerSubscribe = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [verificationCode, setVerificationCode] = useState('');
//   const [step, setStep] = useState('checking');
//   const [error, setError] = useState('');
//   const [restaurant, setRestaurant] = useState(null);
//   const [otpTimer, setOtpTimer] = useState(OTP_EXPIRY_TIME);
//   const [otpInterval, setOtpInterval] = useState(null);
//   const { restaurantId } = useParams();
//   const navigate = useNavigate();
//   const [token, setToken] = useState(localStorage.getItem('customerToken'));

//   // Add processing states
//   const [isProcessingPhone, setIsProcessingPhone] = useState(false);
//   const [isProcessingVerification, setIsProcessingVerification] =
//     useState(false);
//   const [isProcessingSubscribe, setIsProcessingSubscribe] = useState(false);
//   const [isProcessingResendOtp, setIsProcessingResendOtp] = useState(false);

//   useEffect(() => {
//     const checkAuthAndSubscription = async () => {
//       if (token) {
//         try {
//           const response = await verifyToken(token);
//           if (response.valid) {
//             const isSubscribed = await checkSubscription();
//             if (isSubscribed) {
//               setStep('success');
//             } else {
//               setStep('subscribe');
//             }
//           } else {
//             setStep('phone');
//           }
//         } catch (error) {
//           setStep('phone');
//         }
//       } else {
//         setStep('phone');
//       }
//     };

//     const fetchRestaurantDetails = async () => {
//       try {
//         const response = await axios.get(`/api/restaurants/${restaurantId}`);
//         setRestaurant(response.data);
//       } catch (error) {
//         setError('Failed to load restaurant information.');
//       }
//     };

//     checkAuthAndSubscription();
//     fetchRestaurantDetails();
//   }, [token, restaurantId]);

//   const checkSubscription = async () => {
//     try {
//       const response = await axios.get(
//         `/api/customers/subscription/${restaurantId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       return response.data.isSubscribed;
//     } catch (error) {
//       return false;
//     }
//   };

//   const handlePhoneSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsProcessingPhone(true); // Show processing state
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       setStep('verify');
//       startOtpTimer();
//     } catch (error) {
//       setError('Failed to send verification code. Please try again.');
//     } finally {
//       setIsProcessingPhone(false); // Hide processing state
//     }
//   };

//   const startOtpTimer = () => {
//     if (otpInterval) clearInterval(otpInterval);
//     setOtpTimer(OTP_EXPIRY_TIME);
//     const interval = setInterval(() => {
//       setOtpTimer((prev) => {
//         if (prev === 1) clearInterval(interval);
//         return prev - 1;
//       });
//     }, 1000);
//     setOtpInterval(interval);
//   };

//   const handleResendOtp = async () => {
//     setError('');
//     setIsProcessingResendOtp(true); // Show processing state for resend OTP
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       startOtpTimer();
//     } catch (error) {
//       setError('Failed to resend OTP. Please try again.');
//     } finally {
//       setIsProcessingResendOtp(false); // Hide processing state
//     }
//   };

//   const handleVerificationSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsProcessingVerification(true); // Show processing state for verification
//     try {
//       const response = await axios.post('/api/auth/customer/verify-otp', {
//         phoneNumber,
//         verificationCode,
//       });
//       if (response.data.token) {
//         localStorage.setItem('customerToken', response.data.token);
//         setToken(response.data.token);
//         const isSubscribed = await checkSubscription();
//         setStep(isSubscribed ? 'success' : 'subscribe');
//       }
//     } catch (error) {
//       setError('Invalid verification code. Please try again.');
//     } finally {
//       setIsProcessingVerification(false); // Hide processing state
//     }
//   };

//   const handleSubscribe = async () => {
//     setError('');
//     setIsProcessingSubscribe(true); // Show processing state for subscription
//     try {
//       const response = await axios.post(
//         `/api/customers/subscribe/${restaurantId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.data.success) {
//         setStep('success');
//       } else {
//         setError('Subscription failed. Please try again.');
//       }
//     } catch (error) {
//       setError('Failed to subscribe. Please try again.');
//       localStorage.removeItem('customerToken');
//       setStep('phone');
//     } finally {
//       setIsProcessingSubscribe(false); // Hide processing state
//     }
//   };

//   const handleGoBack = () => {
//     setStep('phone');
//     setVerificationCode('');
//     clearInterval(otpInterval);
//     setOtpTimer(OTP_EXPIRY_TIME);
//   };

//   const renderStep = () => {
//     switch (step) {
//       case 'checking':
//         return <div>Checking your authentication...</div>;
//       case 'phone':
//         return (
//           <form onSubmit={handlePhoneSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='phoneNumber'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Phone Number
//               </label>
//               <input
//                 type='tel'
//                 id='phoneNumber'
//                 value={phoneNumber}
//                 onChange={(e) => setPhoneNumber(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter your phone number'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//               disabled={isProcessingPhone}
//             >
//               {isProcessingPhone ? 'Processing...' : 'Send Verification Code'}
//             </button>
//           </form>
//         );
//       case 'verify':
//         return (
//           <form onSubmit={handleVerificationSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='verificationCode'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Verification Code
//               </label>
//               <input
//                 type='text'
//                 id='verificationCode'
//                 value={verificationCode}
//                 onChange={(e) => setVerificationCode(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter verification code'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//               disabled={isProcessingVerification}
//             >
//               {isProcessingVerification
//                 ? 'Processing...'
//                 : 'Verify and Subscribe'}
//             </button>
//             <button
//               onClick={handleGoBack}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400'
//             >
//               Go Back
//             </button>
//             <button
//               onClick={handleResendOtp}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400'
//               disabled={isProcessingResendOtp}
//             >
//               {isProcessingResendOtp ? 'Processing...' : 'Resend OTP'}
//             </button>
//             <p>OTP expires in {otpTimer} seconds</p>
//           </form>
//         );
//       case 'subscribe':
//         return (
//           <div className='text-center'>
//             <p className='text-xl font-semibold text-gray-600 mb-4'>
//               Subscribe to receive updates from {restaurant?.name}
//             </p>
//             <button
//               onClick={handleSubscribe}
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//               disabled={isProcessingSubscribe}
//             >
//               {isProcessingSubscribe ? 'Processing...' : 'Subscribe'}
//             </button>
//           </div>
//         );
//       case 'success':
//         return (
//           <div className='text-center'>
//             <p className='text-xl font-semibold text-green-600 mb-4'>
//               Successfully Subscribed!
//             </p>
//             <p>You will now receive messages from {restaurant?.name}.</p>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
//       {restaurant && (
//         <h1 className='text-2xl font-bold mb-4 text-center'>
//           {restaurant.name}
//         </h1>
//       )}
//       {renderStep()}
//     </div>
//   );
// };

// export default CustomerSubscribe;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { verifyToken } from '../services/authService';

// const OTP_EXPIRY_TIME = 300; // 5 minutes (in seconds)

// const CustomerSubscribe = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [verificationCode, setVerificationCode] = useState('');
//   const [step, setStep] = useState('checking'); // Possible steps: 'checking', 'phone', 'verify', 'subscribe', 'success'
//   const [error, setError] = useState('');
//   const [restaurant, setRestaurant] = useState(null); // To store restaurant details
//   const [otpTimer, setOtpTimer] = useState(OTP_EXPIRY_TIME);
//   const [otpInterval, setOtpInterval] = useState(null);
//   const { restaurantId } = useParams();
//   const navigate = useNavigate();
//   const [token, setToken] = useState(localStorage.getItem('customerToken'));

//   useEffect(() => {
//     const checkAuthAndSubscription = async () => {
//       if (token) {
//         try {
//           const response = await verifyToken(token);
//           if (response.valid) {
//             const isSubscribed = await checkSubscription();
//             if (isSubscribed) {
//               setStep('success'); // Already subscribed
//             } else {
//               setStep('subscribe'); // Show subscribe button
//             }
//           } else {
//             setStep('phone');
//           }
//         } catch (error) {
//           setStep('phone');
//         }
//       } else {
//         setStep('phone');
//       }
//     };

//     const fetchRestaurantDetails = async () => {
//       try {
//         const response = await axios.get(`/api/restaurants/${restaurantId}`);
//         setRestaurant(response.data);
//       } catch (error) {
//         setError('Failed to load restaurant information.');
//       }
//     };

//     checkAuthAndSubscription();
//     fetchRestaurantDetails();
//   }, [token, restaurantId]);

//   const checkSubscription = async () => {
//     try {
//       const response = await axios.get(
//         `/api/customers/subscription/${restaurantId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       return response.data.isSubscribed;
//     } catch (error) {
//       return false;
//     }
//   };

//   const handlePhoneSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       setStep('verify');
//       startOtpTimer();
//     } catch (error) {
//       setError('Failed to send verification code. Please try again.');
//     }
//   };

//   const startOtpTimer = () => {
//     if (otpInterval) clearInterval(otpInterval);
//     setOtpTimer(OTP_EXPIRY_TIME); // Reset the timer
//     const interval = setInterval(() => {
//       setOtpTimer((prev) => {
//         if (prev === 1) clearInterval(interval);
//         return prev - 1;
//       });
//     }, 1000);
//     setOtpInterval(interval);
//   };

//   const handleResendOtp = async () => {
//     setError('');
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       startOtpTimer(); // Reset OTP timer on resend
//     } catch (error) {
//       setError('Failed to resend OTP. Please try again.');
//     }
//   };

//   const handleVerificationSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       const response = await axios.post('/api/auth/customer/verify-otp', {
//         phoneNumber,
//         verificationCode,
//       });
//       if (response.data.token) {
//         localStorage.setItem('customerToken', response.data.token);
//         setToken(response.data.token);
//         const isSubscribed = await checkSubscription();
//         setStep(isSubscribed ? 'success' : 'subscribe');
//       }
//     } catch (error) {
//       setError('Invalid verification code. Please try again.');
//     }
//   };

//   const handleSubscribe = async () => {
//     try {
//       const response = await axios.post(
//         `/api/customers/subscribe/${restaurantId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.data.success) {
//         setStep('success');
//       } else {
//         setError('Subscription failed. Please try again.');
//       }
//     } catch (error) {
//       setError('Failed to subscribe. Please try again.');
//       localStorage.removeItem('customerToken');
//       setStep('phone');
//     }
//   };

//   const handleGoBack = () => {
//     setStep('phone');
//     setVerificationCode('');
//     clearInterval(otpInterval); // Clear timer when going back
//     setOtpTimer(OTP_EXPIRY_TIME); // Reset timer
//   };

//   const renderStep = () => {
//     switch (step) {
//       case 'checking':
//         return <div>Checking your authentication...</div>;
//       case 'phone':
//         return (
//           <form onSubmit={handlePhoneSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='phoneNumber'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Phone Number
//               </label>
//               <input
//                 type='tel'
//                 id='phoneNumber'
//                 value={phoneNumber}
//                 onChange={(e) => setPhoneNumber(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter your phone number'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//             >
//               Send Verification Code
//             </button>
//           </form>
//         );
//       case 'verify':
//         return (
//           <form onSubmit={handleVerificationSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='verificationCode'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Verification Code
//               </label>
//               <input
//                 type='text'
//                 id='verificationCode'
//                 value={verificationCode}
//                 onChange={(e) => setVerificationCode(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter verification code'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//             >
//               Verify and Subscribe
//             </button>
//             <button
//               onClick={handleGoBack}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400'
//             >
//               Go Back
//             </button>
//             <button
//               onClick={handleResendOtp}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400'
//             >
//               Resend OTP
//             </button>
//             <p>OTP expires in {otpTimer} seconds</p>
//           </form>
//         );
//       case 'subscribe':
//         return (
//           <div className='text-center'>
//             <p className='text-xl font-semibold text-green-600 mb-4'>
//               Subscribe to this restaurant?
//             </p>
//             <button
//               onClick={handleSubscribe}
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//             >
//               Subscribe
//             </button>
//           </div>
//         );
//       case 'success':
//         return (
//           <div className='text-center'>
//             <p className='text-xl font-semibold text-green-600 mb-4'>
//               You are already subscribed!
//             </p>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
//       {restaurant && (
//         <h1 className='text-2xl font-bold mb-4 text-center'>
//           {restaurant.name}
//         </h1>
//       )}
//       {error && <p className='text-red-500 text-sm mb-4'>{error}</p>}
//       {renderStep()}
//     </div>
//   );
// };

// export default CustomerSubscribe;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// // import api from '../utils/api';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { verifyToken } from '../services/authService';

// const CustomerSubscribe = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [verificationCode, setVerificationCode] = useState('');
//   const [step, setStep] = useState('phone'); // 'phone', 'verify', or 'success'
//   const [error, setError] = useState('');
//   const [restaurant, setRestaurant] = useState(null);
//   const { restaurantId } = useParams(); // Extract restaurantId from URL params
//   const navigate = useNavigate();
//   let token = localStorage.getItem('customerToken');

//   useEffect(() => {
//     const autologin = async () => {
//       // const token = localStorage.getItem('customerToken');
//       // subscribeToRestaurant(token);

//       if (token) {
//         const response = await verifyToken(token);
//         console.log(response);
//         if (response.valid) {
//           setStep('subscribe');
//         }
//       }
//     };
//     autologin();
//   }, [token]);

//   const subscribeToRestaurant = async () => {
//     try {
//       // const token = localStorage.getItem('customerToken');
//       const response = await axios.post(
//         `/api/customers/subscribe/${restaurantId}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       if (response.data.success) {
//         alert('You have successfully subscribed to the restaurant!');
//         setStep('success');
//       } else {
//         alert('Subscription failed. Please try again.');
//       }
//     } catch (error) {
//       alert(
//         'Failed to subscribe. Please ensure you are logged in and try again.'
//       );
//       localStorage.removeItem('customerToken');
//       setStep('phone');
//     }
//   };

//   const handlesubscribeclick = async (e) => {
//     e.preventDefault();
//     subscribeToRestaurant();
//   };

//   //   useEffect(() => {
//   //     const fetchRestaurant = async () => {
//   //       try {
//   //         const response = await axios.get(`/api/restaurants/${restaurantId}`);
//   //         setRestaurant(response.data);
//   //         setStep('success');
//   //       } catch (error) {
//   //         console.error('Error fetching restaurant:', error);
//   //         setError('Failed to load restaurant information.');
//   //       }
//   //     };

//   //     if (restaurantId) {
//   //       fetchRestaurant();
//   //     } else {
//   //       setError('Restaurant ID is missing.');
//   //     }
//   //   }, [restaurantId]);

//   const handlePhoneSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       await axios.post(
//         // `/api/${restaurantId}/customers/send-verification`,
//         '/api/auth/customer/login',
//         {
//           phoneNumber,
//         }
//       );
//       setStep('verify');
//     } catch (error) {
//       console.error('Error sending verification code:', error);
//       setError('Failed to send verification code. Please try again.');
//     }
//   };

//   const handleVerificationSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       const response = await axios.post(`/api/auth/customer/verify-otp`, {
//         phoneNumber,
//         verificationCode,
//       });
//       //   console.log(response);
//       if (response.data.token) {
//         localStorage.setItem('customerToken', response.data.token);
//         token = localStorage.getItem('customerToken');
//       }
//       setStep('subscribe');
//     } catch (error) {
//       console.error('Error verifying code:', error);
//       setError('Invalid verification code. Please try again.');
//     }
//   };

//   //   if (!restaurant) {
//   //     return <div className='text-center mt-8'>Loading...</div>;
//   //   }

//   return (
//     <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
//       {/* <h1 className='text-2xl font-bold mb-4 text-center'>{restaurant.name}</h1> */}
//       <h2 className='text-xl mb-6 text-center'>Subscribe to Our Messages</h2>

//       {step === 'phone' && (
//         <form onSubmit={handlePhoneSubmit} className='space-y-4'>
//           <div>
//             <label
//               htmlFor='phoneNumber'
//               className='block text-sm font-medium text-gray-700'
//             >
//               Phone Number
//             </label>
//             <input
//               type='tel'
//               id='phoneNumber'
//               value={phoneNumber}
//               onChange={(e) => setPhoneNumber(e.target.value)}
//               required
//               className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//               placeholder='Enter your phone number'
//             />
//           </div>
//           {error && <p className='text-red-500 text-sm'>{error}</p>}
//           <button
//             type='submit'
//             className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//           >
//             Send Verification Code
//           </button>
//         </form>
//       )}

//       {step === 'verify' && (
//         <form onSubmit={handleVerificationSubmit} className='space-y-4'>
//           <div>
//             <label
//               htmlFor='verificationCode'
//               className='block text-sm font-medium text-gray-700'
//             >
//               Verification Code
//             </label>
//             <input
//               type='text'
//               id='verificationCode'
//               value={verificationCode}
//               onChange={(e) => setVerificationCode(e.target.value)}
//               required
//               className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//               placeholder='Enter verification code'
//             />
//           </div>
//           {error && <p className='text-red-500 text-sm'>{error}</p>}
//           <button
//             type='submit'
//             className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//           >
//             Verify and Subscribe
//           </button>
//         </form>
//       )}

//       {step === 'success' && (
//         <div className='text-center'>
//           <p className='text-xl font-semibold text-green-600 mb-4'>
//             Successfully Subscribed!
//           </p>
//           {/* <p>You will now receive messages from {restaurant.name}.</p> */}
//         </div>
//       )}

//       {step === 'subscribe' && (
//         <div className='text-center'>
//           <p className='text-xl font-semibold text-green-600 mb-4'>
//             Subscribe?
//           </p>
//           {/* <p>Click to subscribe {restaurant.name}.</p> */}
//           <button
//             onClick={handlesubscribeclick}
//             className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//           >
//             subscribe?{' '}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomerSubscribe;
